import Russian from './ru.json';
import English from './en.json';

export const languages: { [key: string]: { [key: string]: string } } = {
  ru: Russian,
  en: English,
};
